import * as React from 'react';
import { Div } from './base';
import { Seo } from './seo';
export const DetailsPageContainer = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Seo, { title: props.title, description: props.description }),
        React.createElement(Div, { as: "main", css: {
                flex: '1',
                minWidth: 0,
                paddingBottom: '$12',
                backgroundColor: '$gray-50',
            } },
            React.createElement(Div, { css: {
                    maxWidth: '$screen2Xl',
                    marginX: 'auto',
                    px: '$6',
                } }, props.children))));
};
//# sourceMappingURL=details-page-container.js.map